import React from 'react';
import ReactDOM from 'react-dom/client';
import { StandaloneComponent } from './StandaloneComponent';
import type { ProcessingData } from './lib/types';
import './styles/globals.css';

// Global mount function that can be called from anywhere
(window as any).mountManufacturingGuide = function (
    containerId: string,
    options: {
        initialQuery?: string;
        apiEndpoint?: string;
        theme?: 'light' | 'dark' | 'system';
        containerClassName?: string;
        onSearch?: (query: string) => void;
        onGuideGenerated?: (data: ProcessingData) => void;
    } = {}
) {
    const container = document.getElementById(containerId);
    if (!container) {
        console.error(`Container with id "${containerId}" not found`);
        return;
    }

    const root = ReactDOM.createRoot(container);
    root.render(
        React.createElement(StandaloneComponent, {
            initialQuery: options.initialQuery || '',
            apiEndpoint: options.apiEndpoint || import.meta.env.VITE_API_BASE_URL || 'https://your-api.com',
            theme: options.theme || 'light',
            containerClassName: options.containerClassName || '',
            onSearch: options.onSearch,
            onGuideGenerated: options.onGuideGenerated,
        })
    );

    // Return cleanup function
    return () => {
        root.unmount();
    };
};

// Auto-mount if data attribute is present
document.addEventListener('DOMContentLoaded', () => {
    const containers = document.querySelectorAll('[data-manufacturing-guide]');
    containers.forEach((container) => {
        const id = container.id;
        if (!id) {
            console.error('Container must have an id attribute');
            return;
        }

        const options = {
            initialQuery: container.getAttribute('data-initial-query') || '',
            apiEndpoint: container.getAttribute('data-api-endpoint') || import.meta.env.VITE_API_BASE_URL || 'https://your-api.com',
            theme: (container.getAttribute('data-theme') as 'light' | 'dark' | 'system') || 'light',
            containerClassName: container.getAttribute('data-container-class') || '',
        };

        (window as any).mountManufacturingGuide(id, options);
    });
});

// Export for module systems
export { StandaloneComponent };

// Export the mount function
export const mountManufacturingGuide = (window as any).mountManufacturingGuide;
